import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  AmlCaseFeatureFlagsDTO,
  PlayerActivityFeatureFlagsDTO,
  PlayerServiceFeatureFlagsDTO,
} from './feature.flags.model';
import { catchError, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  constructor(private http: HttpClient) {}

  getPlayerServiceFeatureFlags(): Observable<PlayerServiceFeatureFlagsDTO> {
    return this.http.get<PlayerServiceFeatureFlagsDTO>('/player/api/feature-flags').pipe(
      catchError((error) => {
        console.error('Feature flags API failed:', error);
        return of({} as PlayerServiceFeatureFlagsDTO);
      })
    );
  }

  getPlayerActivityFeatureFlags(): Observable<PlayerActivityFeatureFlagsDTO> {
    return this.http.get<PlayerActivityFeatureFlagsDTO>('/player-activity/api/feature-flags').pipe(
      catchError((error) => {
        console.error('Feature flags API failed:', error);
        return of({} as PlayerActivityFeatureFlagsDTO);
      })
    );
  }

  getAmlCaseFeatureFlags(): Observable<AmlCaseFeatureFlagsDTO> {
    return this.http.get<AmlCaseFeatureFlagsDTO>('/aml-case/api/backoffice/feature-flags').pipe(
      catchError((error) => {
        console.error('AML Case feature flags API failed:', error);
        return of({} as AmlCaseFeatureFlagsDTO);
      })
    );
  }
}
